import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var accordionBehavior = function accordionBehavior() {
  Alpine.data('accordionBehavior', function () {
    return {
      accordionIsOpen: false,
      init: function init() {
        this.accordion = this.$el;
        this.accordionComponents = this.accordion.querySelectorAll('.o-accordion__components');
        this.accordionDefaultState = this.accordionComponents[0].getAttribute('data-default-state');
        this.accordionIsOpen = this.accordionDefaultState === 'open' ? 1 : 0;
      },
      clicked: function clicked() {
        this.accordionIsOpen = !this.accordionIsOpen;
        // Return user to top of accordion element.
        if (!this.accordionIsOpen) {
          this.accordion.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    };
  });
};